var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SingleEntryOrList',{attrs:{"data-list":_vm.getList,"single-entry-component-name":_vm.singleEntryComponentName,"list-entry-component-name":_vm.listEntryComponentName}})}
var staticRenderFns = []

export { render, staticRenderFns }